import { useAPIExplorer } from "../APIExplorerContext"
import {
  RequestFormInput,
  RequestLangFieldset,
  RequestTypeFieldset,
} from "./components"
import { RequestRefFieldset } from "./components/RequestRefFieldset"
import { createRequest } from "./createRequest"

export const GetByUIDRequest = createRequest({
  type: "getByUID",
  Fieldset() {
    const { request } = useAPIExplorer()

    function setUID(uid: string) {
      request.setRequestOptions("getByUID", {
        ...request.options.getByUID,
        uid,
      })
    }

    return (
      <>
        <RequestRefFieldset />
        <RequestTypeFieldset />
        <RequestFormInput
          value={request.options.getByUID?.["uid"] ?? ""}
          onValueChange={setUID}
          label="UID *"
          placeholder="homepage"
          error={!request.options.getByUID?.["uid"]}
        />
        <RequestLangFieldset />
      </>
    )
  },
  getSnippet(options) {
    const clientOptions: string[] = []

    if (options.lang) {
      clientOptions.push(`    lang: "${options.lang}"`)
    }
    if (options.ref) {
      clientOptions.push(`    ref: "${options.ref}"`)
    }

    return clientOptions.length
      ? `client.getByUID(\n  ${options["type"] ? `"${options["type"]}"` : "type"},\n  ${options["uid"] ? `"${options["uid"]}"` : "uid"},\n  {\n${clientOptions.join(",\n")}\n  }\n)`
      : `client.getByUID(${options["type"] ? `"${options["type"]}"` : "type"}, ${options["uid"] ? `"${options["uid"]}"` : "uid"})`
  },
  run(client, options) {
    return client.getByUID(String(options["type"]), String(options["uid"]), {
      lang: options.lang,
      ref: options.ref,
    })
  },
})
